import * as React from "react";

interface AdditionalCostProps {
  label: string;
  cost: number;
  onCostChange: (cost: number) => void;
  unit?: string;
  currency: "RON" | "EUR";
}

const AdditionalCost: React.FC<AdditionalCostProps> = ({
  label,
  cost,
  onCostChange,
  unit,
  currency,
}) => {
  const [inputValue, setInputValue] = React.useState<number | "">(cost);

  React.useEffect(() => {
    if (typeof cost === "number" && !isNaN(cost)) setInputValue(cost);
  }, [cost]);

  const onFocus = () => {
    if (inputValue === 0) setInputValue("");
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let v = e.target.value.replace(/^0+/, "");
    if (v === "") setInputValue("");
    else setInputValue(Number(v));
  };

  const onBlur = () => {
    if (inputValue === "" || isNaN(Number(inputValue))) {
      setInputValue(0);
      onCostChange(0);
    } else {
      onCostChange(Number(inputValue));
    }
  };

  return (
    <div className="flex items-center justify-between bg-gray-100 rounded-lg p-4 w-full">
      <span className="text-primary text-lg sm:text-2xl font-ubuntu font-medium">
        {label}
      </span>
      <div className="flex items-center">
        <input
          type="number"
          value={inputValue === 0 ? "" : inputValue}
          onFocus={onFocus}
          onChange={handleChange}
          onBlur={onBlur}
          min={0}
          className="font-ubuntu text-primary text-2xl sm:text-3xl font-bold bg-transparent w-16 sm:w-20 text-right appearance-none [-moz-appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
          placeholder="0"
        />
        {unit && (
          <span className="font-ubuntu text-primary text-2xl sm:text-3xl font-bold ml-1">
            /{unit}
          </span>
        )}
        <span className="font-ubuntu text-primary text-2xl sm:text-3xl font-bold ml-2">
          {currency}
        </span>
      </div>
    </div>
  );
};

export default AdditionalCost;
